import React, { useEffect, useRef } from 'react';

const PARTICLE_COUNT = 60;
const COLORS = ['#c9a44a', '#ff6a1a', '#5b7cfa'];

const ParticleField = ({ className = 'fixed inset-0 z-0' }) => {
	const canvasRef = useRef(null);

	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		let width = (canvas.width = window.innerWidth);
		let height = (canvas.height = window.innerHeight);
		let mouseX = width / 2;
		let mouseY = height / 2;

		const particles = Array.from({ length: PARTICLE_COUNT }, () => ({
			x: Math.random() * width,
			y: Math.random() * height,
			r: Math.random() * 1.6 + 0.6,
			speed: Math.random() * 0.3 + 0.1,
			drift: Math.random() * 0.4 - 0.2,
			color: COLORS[Math.floor(Math.random() * COLORS.length)],
			alpha: Math.random() * 0.5 + 0.2,
		}));

		const handleResize = () => {
			width = canvas.width = window.innerWidth;
			height = canvas.height = window.innerHeight;
		};
		const handleMouseMove = e => {
			mouseX = e.clientX;
			mouseY = e.clientY;
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('mousemove', handleMouseMove);

		let frameId;
		const draw = () => {
			ctx.clearRect(0, 0, width, height);
			const parallaxX = (mouseX / width - 0.5) * 12;
			const parallaxY = (mouseY / height - 0.5) * 12;

			particles.forEach(p => {
				if (!prefersReducedMotion) {
					p.y -= p.speed;
					p.x += p.drift;
					if (p.y < -10) {
						p.y = height + 10;
						p.x = Math.random() * width;
					}
					if (p.x < -10) p.x = width + 10;
					if (p.x > width + 10) p.x = -10;
				}

				ctx.beginPath();
				ctx.arc(p.x + parallaxX, p.y + parallaxY, p.r, 0, Math.PI * 2);
				ctx.fillStyle = p.color;
				ctx.globalAlpha = p.alpha;
				ctx.fill();
			});
			ctx.globalAlpha = 1;
			if (!prefersReducedMotion) frameId = requestAnimationFrame(draw);
		};

		draw();

		return () => {
			cancelAnimationFrame(frameId);
			window.removeEventListener('resize', handleResize);
			window.removeEventListener('mousemove', handleMouseMove);
		};
	}, []);

	return (
		<canvas
			ref={canvasRef}
			className={`${className} pointer-events-none opacity-70`}
			aria-hidden="true"
		/>
	);
};

export default ParticleField;
